import { capitalize, FormControl, Grid, InputLabel, MenuItem, Paper, Select } from '@material-ui/core'
import React from 'react'
import { nearestCompletedFiscalQuarter } from '../util/fiscalQuarterFunctions'

export default function FiscalQuarterFilter(props) {
    return (
        <Grid justify="center" item xs={12} container component={Paper} style={{ padding: 10, marginRight: 10 }}>
            <Grid item xs={12}>
                <FormControl fullWidth >
                    <InputLabel style={{ color: !props.closed_fiscal_quarter.includes('All') ? '#4472c4' : '#000' }} id="select-vfiscalQuarter-label">{`${(props.type).split("_").map(item => capitalize(item)).join(" ")}: `}</InputLabel>
                    <Select
                        data-test="Closed Fiscal Qtr"
                        labelId="select-vfiscalQuarter-label"
                        id="select-cfiscalQuarter"
                        value={props.closed_fiscal_quarter}
                        onChange={props.handleChange}
                        label="Closed Fiscal Quarter"
                        name={props.type}
                        multiple
                    >
                        <MenuItem value={'All'} >All</MenuItem>
                        {props.funnelCompareFilters === '' && <MenuItem value={nearestCompletedFiscalQuarter()} >{nearestCompletedFiscalQuarter()}</MenuItem>}
                        {props.funnelCompareFilters !== '' && props.funnelCompareFilters.filter(y => y.type === props.type && y[props.type] !== '')
                            .map(y => <MenuItem key={y[props.type]} value={y[props.type]}>{y[props.type]}</MenuItem>)}
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    )
}
